import { render, staticRenderFns } from "./OrganizationNavFragment.vue?vue&type=template&id=ccb3acca&scoped=true&"
import script from "./OrganizationNavFragment.vue?vue&type=script&lang=js&"
export * from "./OrganizationNavFragment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccb3acca",
  null
  
)

export default component.exports